import React from 'react';
import _ from 'lodash';
import autoBind from 'react-autobind';
import * as commonActionType from '@common/store/common/common.actionsType';
import { Editor, EditorTools, EditorToolsSettings, EditorUtils, ProseMirror } from '@progress/kendo-react-editor';
import PubSub from 'pubsub-js';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

const { EditorState, EditorView, Plugin, PluginKey } = ProseMirror;

const {
  Bold,
  Italic,
  FontSize,
  Underline,
  AlignLeft,
  AlignRight,
  AlignCenter,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  Undo,
  Redo,
  FontName,
  Link,
  Unlink,
} = EditorTools;

for (var key in EditorToolsSettings) {
  if (EditorToolsSettings[key].props) {
    EditorToolsSettings[key].props.type = 'button';
    EditorToolsSettings[key].props.className = 'form-control';
  }
}

class RichTextComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      state: undefined,
      value: undefined,
      editable: props.ReadOnly,
      editorDefined: false,
    };

    autoBind(this);
  }

  editable = () => !this.state.editable;

  onMount = (event) => {
    const state = event.viewProps.state;

    const plugins = [
      ...state.plugins,
      new Plugin({
        key: new PluginKey('readonly'),
        props: {
          editable: this.editable,
        },
      }),
    ];

    return new EditorView(
      {
        mount: event.dom,
      },
      {
        ...event.viewProps,
        state: EditorState.create({
          doc: state.doc,
          plugins,
        }),
      }
    );
  };

  componentDidMount() {
    PubSub.subscribe(commonActionType.RESET, this.clear.bind(this));
  }

  static getDerivedStateFromProps(nextProps, currentState) {
    const { value } = nextProps;
    if (JSON.stringify(value) != JSON.stringify(currentState.value)) {
      return {
        value,
      };
    }
    return null;
  }

  componentDidUpdate(prevState) {
    var editorLoaded = this.state.editorDefined;

    if (!!this.editor) editorLoaded = true;

    if (prevState.value != this.state.value || (editorLoaded && !this.state.editorDefined)) {
      this.setHtml(this.state.value || '');

      if (editorLoaded) this.state.editorDefined = true;
    }
  }

  clear() {
    this.setHtml('');
  }

  handleHighlightVariables(templateEmail) {
    const patternVariables = new RegExp(/{([^}]+)}/g);

    var matches = templateEmail.match(patternVariables);

    if (matches != null) {
      const handleHighLightVariable = (match) => {
        var highLightedVariable = `&hairsp;<span style="background-color: #eee; padding: 1.5px;border-radius: 4px;border: solid 1px rgba(255, 0, 0, 0.301);font-family: monospace">${match}</span>&hairsp;`;
        templateEmail = templateEmail.replaceAll(match, highLightedVariable);
      };

      matches.forEach((match) => handleHighLightVariable(match));
    }

    return templateEmail;
  }

  setHtml(value) {
    const { view } = this.editor.state;

    const { ReadOnly } = this.props;

    const formattedHtml = ReadOnly ? value : this.handleHighlightVariables(value);

    EditorUtils.setHtml(view, formattedHtml);
  }

  onChange({ state, transaction }) {
    if (
      state.doc.eq(transaction.doc) ||
      transaction.meta.commandName == 'SetContent' ||
      transaction.meta.commandName == 'setHTML'
    ) {
      return;
    }

    const nextState = ProseMirror.EditorState.create({
      doc: transaction.doc,
      selection: transaction.selection,
    });

    var result = EditorUtils.getHtml(nextState);

    this.props.onChangeAsync(result);
  }

  render() {
    const { Label, Altura, Tooltip, Placeholder, Obrigatorio, Desabilitado, Tamanho, name, ReadOnly } = this.props;

    const tools = ReadOnly
      ? []
      : [
          [Bold, Italic, Underline],
          [Undo, Redo],
          [FontName, FontSize],
          [AlignLeft, AlignCenter, AlignRight],
          [OrderedList, UnorderedList, Indent, Outdent, Link, Unlink],
        ];

    return (
      <OverlayTrigger
        key={`top-${name}`}
        placement="top"
        overlay={
          !ReadOnly ? (
            <TooltipBootstrap id={`tooltip-${name}`}>
              <div className="fontTooltip">{Tooltip || Label}</div>
            </TooltipBootstrap>
          ) : (
            <div />
          )
        }
      >
        <div>
          <Editor
            tools={tools}
            defaultContent=""
            contentStyle={{ height: Altura || 320 }}
            disabled={Desabilitado}
            required={Obrigatorio}
            maxLength={Tamanho}
            style={ReadOnly && { backgroundColor: '#eee' }}
            onMount={ReadOnly && this.onMount}
            onExecute={this.onChange}
            placeholder={Placeholder || Label}
            ref={(editor) => (this.editor = editor)}
            defaultEditMode={'div'}
          />
        </div>
      </OverlayTrigger>
    );
  }
}

export default RichTextComponent;
